var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7972 21.1758C20.7434 21.2738 20.6642 21.3556 20.568 21.4126C20.4719 21.4696 20.3621 21.4998 20.2503 21.5H16.5003C16.3951 21.5 16.2916 21.4734 16.1995 21.4227C16.1073 21.3721 16.0294 21.2989 15.973 21.2102L12.8097 16.2391L8.2128 21.2953C8.10074 21.4157 7.94575 21.487 7.78143 21.4939C7.61712 21.5008 7.45671 21.4426 7.335 21.332C7.21329 21.2214 7.14008 21.0673 7.13125 20.903C7.12241 20.7388 7.17866 20.5777 7.2878 20.4547L12.1136 15.1422L7.22296 7.46094C7.16273 7.36644 7.12901 7.25749 7.12534 7.14548C7.12166 7.03348 7.14817 6.92255 7.20208 6.82431C7.256 6.72607 7.33533 6.64413 7.43178 6.58708C7.52823 6.53002 7.63824 6.49995 7.7503 6.5H11.5003C11.6055 6.50003 11.709 6.52661 11.8012 6.57728C11.8933 6.62795 11.9712 6.70106 12.0276 6.78984L15.1909 11.7609L19.7878 6.70469C19.8999 6.58431 20.0549 6.51296 20.2192 6.50609C20.3835 6.49923 20.5439 6.5574 20.6656 6.66801C20.7873 6.77862 20.8605 6.93275 20.8694 7.09697C20.8782 7.2612 20.8219 7.42228 20.7128 7.54531L15.887 12.8539L20.7776 20.5398C20.8375 20.6344 20.871 20.7433 20.8744 20.8551C20.8778 20.967 20.8512 21.0777 20.7972 21.1758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.acc77f3f23114467e47860093e40bd24.svg";
export { ForwardRef as ReactComponent };